import { footerLinks, siteMeta } from "@/mocks/news";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-accent-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-plant-line text-lg" aria-hidden />
              </span>
              <span className="font-heading text-lg font-black">{siteMeta.name}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/70">
              {siteMeta.description}
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-100/80">
              <i className="ri-mail-line text-secondary-300" aria-hidden />
              {siteMeta.email}
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
                {group.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.label}`}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/70 transition-colors hover:text-secondary-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/60">
            © {year} {siteMeta.name} · 内容仅为线索整理，与一切商业推广无关
          </p>
          <p className="text-xs text-background-100/60">
            标注来源与状态的爆料，才值得被转发
          </p>
        </div>
      </div>
    </footer>
  );
}